<template>
    <div>
        <headline-container headline="Create Subscription Type" :breadcrumbs="breadcrumbs"></headline-container>

        <loading-container v-if="loading"></loading-container>

        <div v-else class="container">
            <div class="row">
                <div class="col-xs-6">
                    <help-text>
                        <h3>
                            Create Subscription Type
                        </h3>

                        <p>
                            Enter the details of the subscription type.
                        </p>
                    </help-text>
                </div>

                <div class="col-xs-18">
                    <div class="panel panel-default">
                        <div class="panel-body">
                            <form @submit.prevent="submit" class="form-horizontal">
                                <text-form-group
                                    v-model="data.name"
                                    name="name"
                                    label="Name"
                                    help-text="The name of the subscription type."
                                    :error="getError('name')"
                                ></text-form-group>

                                <number-form-group
                                    v-model="data.price"
                                    name="price"
                                    label="Price"
                                    help-text="The price of subscriptions with this type."
                                    :error="getError('price')"
                                ></number-form-group>

                                <number-form-group
                                    v-model="data.period"
                                    name="period"
                                    label="Period"
                                    help-text="The period (in months) of subscriptions with this type."
                                    :error="getError('period')"
                                ></number-form-group>

                                <number-form-group
                                    v-model="data.closes_after"
                                    name="closes_after"
                                    label="Closes After"
                                    help-text="The number of days that subscriptions with this type will remain open with an unpaid invoice."
                                    :error="getError('closes_after')"
                                ></number-form-group>

                                <number-form-group
                                    v-model="data.seats"
                                    name="seats"
                                    label="Seats"
                                    help-text="The number of seats that subscriptions with this type will grant on the portal."
                                    :error="getError('seats')"
                                ></number-form-group>

                                <select-form-group
                                    v-model="data.portal_id"
                                    name="portal_id"
                                    label="Portal"
                                    help-text="The portal where this subscription type exists."
                                    :error="getError('portal_id')"
                                    :nullable="true"
                                    :options="portalOptions"
                                ></select-form-group>

                                <hr>

                                <submit-form-group button-class="btn-black"></submit-form-group>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import http from '@/http'
import notify from '@/notify'
import Errors from '@/mixins/Errors'
import HeadlineContainer from '@/components/Layout/HeadlineContainer'
import HelpText from '@/components/HelpText'
import LoadingContainer from '@/components/Layout/LoadingContainer'
import NumberFormGroup from '@/vendor/forms/FormGroups/Horizontal/Number'
import SelectFormGroup from '@/vendor/forms/FormGroups/Horizontal/Select'
import SubmitFormGroup from '@/vendor/forms/FormGroups/Horizontal/Submit'
import TextFormGroup from '@/vendor/forms/FormGroups/Horizontal/Text'

export default {
    components: {
        HeadlineContainer,
        HelpText,
        LoadingContainer,
        NumberFormGroup,
        SelectFormGroup,
        SubmitFormGroup,
        TextFormGroup
    },

    mixins: [Errors],

    data() {
        return {
            data: {},
            portals: [],

            loading: true
        }
    },

    mounted() {
        this.load()
    },

    computed: {
        breadcrumbs() {
            return [
                {url: '/subscription-types', text: 'Subscription Types'},
                {text: 'Create'}
            ]
        },

        portalOptions() {
            return this.portals.map(portal => {
                return {
                    value: portal.id,
                    label: portal.attributes.name
                }
            })
        }
    },

    methods: {
        load() {
            http.get('/api/v2/portals').then(response => {
                this.portals = response.data.data

                this.loading = false
            })
        },

        submit() {
            http.post('/api/v2/subscription-types', this.data)
                .then(() => {
                    notify.success('The subscription type was saved')

                    this.$router.push('/subscription-types')
                })
                .catch(this.catchValidationErrors)
        }
    }
}
</script>
